import { z } from 'zod'
import { DASHBOARD_PLUGIN_KEYS } from '../../enums/dashboard-plugin-key.enum'
import { dashboardPluginSizeSchema } from './dashboard-plugin-size.schema'

export const dashboardPluginResponseSchema = z.object({
  id: z.string().guid(),
  pluginKey: z.enum(DASHBOARD_PLUGIN_KEYS),
  order: z.number().int(),
  size: dashboardPluginSizeSchema,
  enabled: z.boolean(),
  config: z.record(z.string(), z.unknown()),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})
export type DashboardPluginResponseDto = z.infer<typeof dashboardPluginResponseSchema>
